import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { project } from "../project";
import { Monitor } from '@tencent/vft-base';
export var monitor = new Monitor({
  project: 'page',
  module: 'default'
});
export function setup() {
  return _setup.apply(this, arguments);
}

function _setup() {
  _setup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref,
        _ref$use,
        use,
        _ref$projectName,
        projectName,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$use = _ref.use, use = _ref$use === void 0 ? true : _ref$use, _ref$projectName = _ref.projectName, projectName = _ref$projectName === void 0 ? '' : _ref$projectName;

            if (use) {
              projectName = projectName || project.name || window.location.pathname;
              monitor.busi.project = projectName;
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setup.apply(this, arguments);
}